// after subscribed to a paid plan
export const showPlanUsageProgressBar = (fullFixelData) => {
  if (fullFixelData.plan && fullFixelData.plan.type && fullFixelData.plan.state) {
    const planType = fullFixelData.plan.type.toLowerCase();
    const planState = fullFixelData.plan.state.toLowerCase();
    const res = planType !== "trial" && planState === "active";
    return res;
  }
};
// while calculating
export const showAnalyzeProgressBar = (fullFixelData) => {
  if (fullFixelData.state === "active") return false;
  const res =
      fullFixelData &&
      fullFixelData.LAST_30_DAYS &&
      fullFixelData.LAST_30_DAYS.fixelStats &&
      (parseInt(fullFixelData.LAST_30_DAYS.fixelStats.total) < 500 ||
          fullFixelData.state === "calculating");
  return res;
};
// after done calculating and no paid plan yet
export const showPotentialRevenue = (fullFixelData) => {
  const res =
      fullFixelData &&
      fullFixelData.plan &&
      fullFixelData.plan.state &&
      fullFixelData.plan.state.toLowerCase() === "active" &&
      fullFixelData.conversions &&
      !!fullFixelData.conversions.potentialRevenue &&
      fullFixelData.plan.type &&
      fullFixelData.plan.type.toLowerCase() === "trial";
  return res;
};
// After successful integration
export const showFBIntegrationSuccessful = (fullFixelData) => {
  const res =
      fullFixelData?.facebook?.status === "connected" &&
      fullFixelData.code !== localStorage.getItem("alertedFBIntegrationSuccessful");
  return res;
};
// After failed integration
export const showIntegrationFailure = (fullFixelData) => {
  const res = fullFixelData?.facebook?.status === "failed" && fullFixelData.code !== localStorage.getItem("alertedFBIntegrationFailure");
  return res;
};
// Trial days count is 7 or less
export const showTrialUnder7Days = (fullFixelData) => {
  const res =
      fullFixelData &&
      fullFixelData.plan &&
      !!fullFixelData.plan.trial_days_remaining &&
      parseInt(fullFixelData.plan.trial_days_remaining) <= 7 &&
      parseInt(fullFixelData.plan.trial_days_remaining) > 0;
  return res;
};
// Trial expired
export const showTrialExpired = (fullFixelData) => {
  const planState =
      fullFixelData &&
      fullFixelData.plan &&
      fullFixelData.plan.state &&
      fullFixelData.plan.state.toLowerCase();
  const trialDaysLeft = fullFixelData.plan && fullFixelData.plan.trial_days_remaining;
  const planType = fullFixelData.plan && fullFixelData.plan.type.toLowerCase();
  const res = planState === "expired" || (trialDaysLeft < 1 && planType === "trial");
  return res;
};
// after reinstall and no active paid plan
export const showNoActivePlan = (fullFixelData) => {
  const segmentState = fullFixelData.state.toLowerCase();
  const planState =
      fullFixelData &&
      fullFixelData.plan &&
      fullFixelData.plan.state &&
      fullFixelData.plan.state.toLowerCase();
  const planType = fullFixelData.plan && fullFixelData.plan.type.toLowerCase();

  const res = planState === "terminated" || (segmentState === "terminated" && planType === "trial");
  return res;
};

// On first entrance after the segment is set to active
export const showSegmentActive = (fullFixelData) => {
  let weekAgo = new Date();
  weekAgo.setDate(weekAgo.getDate() - 7);
  const res =
      fullFixelData.state === "active" &&
      fullFixelData.last_state_change > +weekAgo &&
      fullFixelData.code !== localStorage.getItem("alertedSegmentActive");
  return res;
};
export const showPlanCancelled = (fullFixelData) => {
  // plan was cancelled
  return false;
};